import {Spin} from "antd"

const Spinner = () => {

    return(
        <div className="spinner">
         <Spin />
        </div>
    )
}

export default Spinner;